import {
  CreateOperationalEntityInput,
  isClientEntityOperational
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode} from "../view-model";
import {toCacmSource} from "./toCacmSource";
import {toOems} from "./toOems";
import {toOrganizationInformation} from "./toOrganizationInformation";

export const toCreateHierarchyInput = (
  node: CreatePlanNode,
  transactionId?: string
): CreateOperationalEntityInput | undefined => {
  if (node.selected) {
    if (isClientEntityOperational(node.source)) {
      // When creating the input for an existing operational entity, the id
      // property tells the BFF that the entity exists. The sources are
      // sent because they are echoed back in the subscription data and
      // the source id is used to locate the result node to update
      const operationalEntity = node.source.mappedOperationalEntities?.[0];
      return {
        transactionId,
        id: operationalEntity?.id,
        sources: [toCacmSource(node.caId)],
        organizationInformation: {
          dbaName:
            operationalEntity?.organizationInformation?.dbaName ||
            node.source.custName,
          status:
            operationalEntity?.organizationInformation?.status || "IN BUSINESS"
        },
        oems: [],
        children: node.children
          .map(child => toCreateHierarchyInput(child, transactionId))
          .filter(input => !!input)
      };
    }
    return {
      transactionId,
      sources: [toCacmSource(node.caId)],
      organizationInformation: toOrganizationInformation(node.source),
      oems: node.source.clientNameplates
        ? toOems(node.source.clientNameplates)
        : [],
      children: node.children
        .map(child => toCreateHierarchyInput(child, transactionId))
        .filter(input => !!input)
    };
  }
};
